import { fields } from "@monorepo/utils/src/variables/projectsData/handoverView/fields";

export const currentFilters = (): Record<string, unknown> => ({
  [fields.HANDOVER_YEAR]: "",
  [fields.HANDOVER_PERIOD_FROM]: "",
  [fields.HANDOVER_PERIOD_TO]: "",
  [fields.OIK_STATUS]: [],
});
